module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCI+PHBhdGggZD0iTTIyIDEzLjc1djcyLjVoNTZ2LTcyLjVIMjJ6bTE4LjMzIDE5SDI3di0zaDEzLjMzdjN6bTYuNjctNy41SDI3di0zaDIwdjN6bTE4Ljc1IDguNWMtMy40NSAwLTYuMjUtMi44LTYuMjUtNi4yNXMyLjgtNi4yNSA2LjI1LTYuMjVTNzIgMjQuMDUgNzIgMjcuNXMtMi44IDYuMjUtNi4yNSA2LjI1eiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_document.svg
// module id = +fjX
// module chunks = 1